import { Box, Button, Typography, createStyles, makeStyles } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import React from 'react';
import PlaceDistance from '../PlaceDistance';
import { availableSessionsLabel } from '../../utils/plural';
var useStyle = makeStyles(function (theme) {
    return createStyles({
        address: {
            color: theme.palette.grey[500],
            fontSize: theme.typography.body1.fontSize,
            fontWeight: 300,
            lineHeight: theme.typography.body1.lineHeight,
            marginBottom: theme.spacing(1),
        },
        btn: {
            width: 190,
        },
        close: {
            position: 'absolute',
            right: 0,
            top: 0,
        },
        distance: {
            paddingLeft: theme.spacing(1),
        },
        name: {
            color: theme.palette.grey[800],
            fontSize: theme.typography.body1.fontSize,
            fontWeight: 'bold',
            lineHeight: theme.typography.body1.lineHeight,
            marginBottom: theme.spacing(1),
        },
        nbSessions: {
            color: theme.palette.primary.main,
            fontSize: theme.typography.body1.fontSize,
            lineHeight: theme.typography.body1.lineHeight,
        },
        price: {
            color: theme.palette.grey[600],
            fontSize: theme.typography.h6.fontSize,
            fontWeight: 300,
            lineHeight: theme.typography.h6.lineHeight,
            marginBottom: theme.spacing(2),
        },
        root: {
            background: '#ffffff',
            borderBottom: "solid " + theme.palette.grey[300] + " 2px",
            display: 'flex',
            minHeight: 140,
            padding: theme.spacing(0),
            paddingLeft: theme.spacing(5),
            paddingRight: theme.spacing(5),
            position: 'relative',
        },
    });
});
export default (function (_a) {
    var name = _a.name, address = _a.address, nbSessions = _a.nbSessions, distance = _a.distance, onClose = _a.onClose, onSubmit = _a.onSubmit, submitDisabled = _a.submitDisabled, price = _a.price;
    var styles = useStyle({});
    var handleCloseClick = function () {
        if (onClose) {
            onClose();
        }
    };
    var handleBookingClick = function () {
        if (onSubmit) {
            onSubmit();
        }
    };
    return (React.createElement(Box, { className: styles.root },
        React.createElement(Box, { display: "flex", width: "50%", alignItems: "center" },
            React.createElement(Box, { display: "flex" },
                React.createElement(Box, { flexGrow: "1", padding: "0 5px" },
                    React.createElement(Typography, { className: styles.name }, name),
                    React.createElement(Typography, { className: styles.address }, address),
                    React.createElement(Typography, { className: styles.nbSessions }, availableSessionsLabel(nbSessions))),
                distance && (React.createElement(Box, { className: styles.distance },
                    React.createElement(PlaceDistance, { distance: distance }))))),
        React.createElement(Box, { display: "flex", width: "50%", alignItems: "center", flexDirection: "column", justifyContent: "center" },
            price && React.createElement(Typography, { className: styles.price },
                "Prix de votre r\u00E9servation : ",
                price,
                "\u20AC"),
            React.createElement(Button, { className: styles.btn, variant: "contained", color: "primary", onClick: handleBookingClick, "arial-label": 'Commencer la réservation', disabled: submitDisabled }, "R\u00E9server")),
        React.createElement(Button, { className: styles.close },
            React.createElement(Close, { onClick: handleCloseClick }))));
});
//# sourceMappingURL=index.js.map